<template>
  <tr class="cat-search-result-row-summary open">
    <td class="search-for-type">
      <span>{{ register }}</span>
    </td>
    <!-- TODO: make name a clickable button -->
    <td class="search-for-name">
      <span class="visible-for-medium"><slot name="view-link"></slot></span>
    </td>
    <td class="search-for-status">
      <span :class="status">{{ status }}</span>
    </td>
  </tr>
</template>

<script lang="ts">
import jQuery from "jquery";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CatSearchResultsRow",
  props: {
    register: [String],
    name: [String],
    status: [String]
  },
  methods: {
    rowClick: function (event) {
      jQuery(event.target).parent().parent().toggleClass("open");
      jQuery(event.target).parent().parent().next().toggleClass("mini");
    }
  }
});
</script>
